var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContactRoleDefaultCtrl = function () {
    function ContactRoleDefaultCtrl($filter) {
        _classCallCheck(this, ContactRoleDefaultCtrl);

        this._translateRole = function (name) {
            return $filter('translate')('gateway.contacts.common.views.roles.' + name);
        };
    }

    _createClass(ContactRoleDefaultCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            var subtype = this.roleType === 'account' ? this.roleModel.subtype : this.roleModel.accountContactRole.subtype;
            this.roleName = this._translateRole(subtype.value.name);
        }
    }]);

    return ContactRoleDefaultCtrl;
}();

ContactRoleDefaultCtrl.$inject = ['$filter'];
export default ContactRoleDefaultCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/roles/ContactRoleDefault/ContactRoleDefaultCtrl.js
// module id = 1642
// module chunks = 0